"use strict";

var Payment = {
  initCounter: 1,
  stripe: undefined,
  stripeData: undefined,
  type: undefined,
  paymentType: PAYMENT_TYPE_CARD,
  couponID: 0,
  autoRenew: 0,
  amount: undefined,
  bonus: undefined,
  appliedBonus: 0,
  bonusType: undefined,
  // 0 - nothing | 1 - wallet | 2 - coupon
  coupon: '',
  payableNow: undefined,
  serviceType: undefined,
  serviceID: undefined,
  stripePaymentIntent: undefined,
  callbackUrlForSofort: undefined,
  callbackUrlForSofortCancel: undefined,
  stripePublishableKey: undefined,
  autoRedirectAfterSofortCallbackUrl: '',
  payButton: '#reserve-money',
  stripeCustomerID: '',
  onload: document.addEventListener('DOMContentLoaded', function () {
    if (PAYMENT_PAGE || PAYMENT_PAGE_EXTEND_OFFER || PAYMENT_TASK_PAGE) Payment.init();
  }),
  init: function init() {
    if (Payment.initCounter === 1) this.bind();
    this.stripe = Stripe(this.stripePublishableKey, {
      'locale': LANGUAGE_VALUE
    });
    this.initPaymentIntent();
    if (Payment.initCounter === 1) Payment.timer(900);
  },
  bind: function bind() {
    $(document).on('click', '.select-pay__btn', function (event) {
      event.preventDefault();
      $(this).closest('.select-pay').find('.select-pay__items').slideToggle("show");
    }).on('click', '.select-pay__items .select-pay__item', function (event) {
      event.preventDefault();
      var block = $('.bank-block');
      var concreteBlock = $(".bank-block[data-id=\"".concat($(this).attr('id'), "\"]"));
      Payment.type = $(this).attr('data-type');
      Payment.paymentType = $(this).attr('data-payment-type');
      $('.select-pay__btn').html($(this).clone());
      block.hide();
      block.find('.select-pay__item').removeClass('select-pay__item--active');
      concreteBlock.show();
      concreteBlock.find('.select-pay__item').addClass('select-pay__item--active');
    });
    $(document).on('click', function (e) {
      if (!$(e.target).closest(".select-pay__btn").length) {
        $('.select-pay__items').slideUp("hide");
      }
      e.stopPropagation();
    }).on('keydown', '[name="billing_data_city"]', function (event) {
      if (event.key.match(/[0-9]/)) return event.preventDefault();
    }).on('input paste', '[name="billing_data_city"], [name="billing_data_first_name"], [name="billing_data_last_name"]', function () {
      $(this).val($(this).val().replace(/[0-9]/g, ""));
    }).on('click', '.wallet-button_btn', function (event) {
      event.preventDefault();
      // $('.wallet-input').slideDown("show").css('display','flex');
      var panel = document.querySelector('.wallet-input');
      console.log(panel);
      panel.classList.add('active');
      $('.wallet-button_btn').hide();
    }).on('click', '#get-max-bonus', function (event) {
      event.preventDefault();
      Payment.ajax.getMaxBonus($(this).attr('data-total'));
    }).on('click', '#approve-bonus', function (event) {
      event.preventDefault();
      Payment.appliedBonus = $('#redeem-bonus-amount').val();
      Payment.bonusType = 1;
      Payment.ajax.changePayoutOptions();
    }).on('click', '#apply-coupon', function (event) {
      event.preventDefault();
      Payment.bonusType = 2;
      Payment.coupon = $('#coupon-code').val();
      Payment.ajax.validateCoupon();
    }).on('click', '#cancel-bonus', function (event) {
      event.preventDefault();
      Payment.coupon = '';
      Payment.bonus = 0;
      Payment.appliedBonus = 0;
      Payment.bonusType = 0;
      Payment.couponID = 0;
      Payment.ajax.changePayoutOptions();
    }).on('change', '[name="payment-gateway-page-payout-option"]', function (event) {
      event.preventDefault();
      $('.payment-option-text').addClass('d-none');
      $("[data-id=\"".concat($(this).attr('id'), "\"]")).removeClass('d-none');
      Payment.ajax.changePayoutOptions();
    });
    $(document).on('click', '.show-coupon', function (e) {
      e.preventDefault();
      $(this).hide();
      $('.coupon-content').css('display', 'flex');
    });
  },
  timer: function timer(duration) {
    setInterval(function () {
      var minutes = parseInt(duration / 60, 10);
      var seconds = parseInt(duration % 60, 10);
      var timerBlock = $('#timer');
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      timerBlock.html(minutes + ":" + seconds);
      if (--duration < 0) window.location.replace(PAYMENT_REDIRECT_URL);
    }, 1000);
  },
  setupElements: function setupElements(data) {
    if (Payment.serviceID == 1 || Payment.serviceID == 2 || Payment.serviceID == 3) {
      return {
        stripe: Payment.stripe,
        card: null,
        clientSecret: data['client_secret'],
        id: data.id,
        amount: data.amount
      };
    } else {
      var elements = Payment.stripe.elements();
      var style = {
        base: {
          color: "#0C1019",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#8492A5"
          }
        },
        invalid: {
          color: "#ED4337",
          iconColor: "#ED4337"
        }
      };
      var card = elements.create("card", {
        style: style
      });
      card.mount("#card-element");
      return {
        stripe: Payment.stripe,
        card: card,
        clientSecret: data['client_secret'],
        id: data.id,
        amount: data.amount
      };
    }
  },
  sofort: function sofort(stripeData) {
    var country = $('select[name=countries]').val();
    if (Payment.serviceID == 1 || Payment.serviceID == 2 || Payment.serviceID == 3) {
      $.ajax({
        url: CLIENT_AJAX_URL,
        method: 'POST',
        data: {
          method: 'createPlanPaymentIntent',
          plan: Payment.serviceID,
          count: 0,
          amount: stripeData.amount,
          currency: 'eur',
          serviceType: Payment.serviceType,
          pMethod: 2,
          serviceID: Payment.serviceID,
          country: country,
          success_url: Payment.callbackUrlForSofort,
          cancel_url: Payment.callbackUrlForSofortCancel
        },
        success: function success(result) {
          // console.log(data.paymentIntent);
          // let paymentIntent = JSON.parse(data.paymentIntent);
          Payment.ajax.savePayment(result.data.paymentIntent.id, result.data.paymentIntent.url);
        }
      });
    } else {
      $.ajax({
        url: CLIENT_AJAX_URL,
        method: 'POST',
        data: {
          method: 'createKlarnaSession',
          amount: stripeData.amount,
          pMethod: 2,
          serviceType: Payment.serviceType,
          serviceID: Payment.serviceID,
          success_url: Payment.callbackUrlForSofort,
          cancel_url: Payment.callbackUrlForSofortCancel
        },
        success: function success(result) {
          Payment.ajax.savePayment(result.data.paymentIntent.id, result.data.paymentIntent.url);
        }
      });
    }
    return false;
  },
  klarna: function klarna(stripeData) {
    $.ajax({
      url: CLIENT_AJAX_URL,
      method: 'POST',
      data: {
        method: 'createKlarnaLink',
        plan: Payment.serviceID,
        count: 0,
        amount: stripeData.amount,
        currency: 'eur',
        serviceType: Payment.serviceType,
        pMethod: 2,
        serviceID: Payment.serviceID,
        country: country,
        success_url: Payment.callbackUrlForSofort,
        cancel_url: Payment.callbackUrlForSofortCancel
      },
      success: function success(result) {
        Payment.ajax.savePayment(result.data.paymentIntent.id, result.data.paymentIntent.url);
      }
    });
    return false;
  },
  ideal: function ideal(stripeData) {
    var name = $('[name="billing_data_first_name"]').val() + ' ' + $('[name="billing_data_last_name"]').val();
    if (Payment.serviceID == 1 || Payment.serviceID == 2 || Payment.serviceID == 3) {
      $.ajax({
        url: CLIENT_AJAX_URL,
        method: 'POST',
        data: {
          method: 'createPlanPaymentIntent',
          plan: Payment.serviceID,
          count: 0,
          amount: stripeData.amount,
          currency: 'eur',
          serviceType: Payment.serviceType,
          pMethod: 3,
          serviceID: Payment.serviceID,
          success_url: Payment.callbackUrlForSofort,
          cancel_url: Payment.callbackUrlForSofortCancel
        },
        success: function success(result) {
          Payment.ajax.savePayment(result.data.paymentIntent.id, result.data.paymentIntent.url);
        }
      });
    } else {
      $.ajax({
        url: CLIENT_AJAX_URL,
        method: 'POST',
        data: {
          method: 'createKlarnaSession',
          plan: Payment.serviceID,
          count: 0,
          amount: stripeData.amount,
          currency: 'eur',
          serviceType: Payment.serviceType,
          pMethod: 3,
          serviceID: Payment.serviceID,
          success_url: Payment.callbackUrlForSofort,
          cancel_url: Payment.callbackUrlForSofortCancel
        },
        success: function success(result) {
          Payment.ajax.savePayment(result.data.paymentIntent.id, result.data.paymentIntent.url);
        }
      });
    }
    return false;
  },
  pay: function pay(stripe, card, clientSecret) {
    if (Payment.serviceID == 1 || Payment.serviceID == 2 || Payment.serviceID == 3) {
      $.ajax({
        url: CLIENT_AJAX_URL,
        method: 'POST',
        data: {
          method: 'createPlanPaymentIntent',
          plan: Payment.serviceID,
          count: 0,
          amount: stripe.amount,
          currency: 'eur',
          serviceType: Payment.serviceType,
          pMethod: 1,
          serviceID: Payment.serviceID,
          success_url: Payment.callbackUrlForSofort,
          cancel_url: Payment.callbackUrlForSofortCancel
        },
        success: function success(result) {
          Payment.ajax.savePayment(result.data.paymentIntent.id, result.data.paymentIntent.url);
        }
      });
    } else {
      var cardholderName = $('#name').val();
      var isSavingCard = false;
      var data = {
        card: card,
        billing_details: {}
      };
      if (cardholderName) {
        data["billing_details"]["name"] = cardholderName;
      }
      Payment.stripe.confirmCardPayment(clientSecret, {
        payment_method: data,
        setup_future_usage: "off_session"
        // setup_future_usage: isSavingCard ? "off_session" : ""
      }).then(function (result) {
        if (result.error) {
          Main.hidePreloader($(Payment.payButton));
          Payment.showGeneralError(result.error.message);
        } else {
          Payment.orderComplete(clientSecret);
        }
      });
    }
    return false;
  },
  showGeneralError: function showGeneralError(text) {
    $(".payment__error").html(text);
    setTimeout(function () {
      $(".payment__error").html('');
    }, 4000);
  },
  orderComplete: function orderComplete(clientSecret) {
    Payment.stripe.retrievePaymentIntent(clientSecret).then(function (result) {
      var paymentIntent = result.paymentIntent;
      $('.payment-view').each(function () {
        $(this).prop('hidden', true);
      });
      $('.completed-view').each(function () {
        $(this).fadeIn();
      });
      if (paymentIntent.status === "requires_capture") {
        Payment.ajax.savePayment(paymentIntent.id);
      } else if (paymentIntent.status === "succeeded") {
        Payment.ajax.savePayment(paymentIntent.id);
      } else {
        document.querySelector(".status").textContent = paymentIntent.status;
        $('.payment-view').each(function () {
          $(this).prop('hidden', false);
        });
        $('.completed-view').each(function () {
          $(this).fadeOut();
        });
      }
    });
  },
  payFunction: function payFunction() {
    Main.showPreloader($(Payment.payButton));
    if (Payment.paymentType === PAYMENT_TYPE_SOFORT) {
      Payment.sofort(Payment.stripeData);
      return false;
    } else if (Payment.paymentType === PAYMENT_TYPE_IDEAL) {
      Payment.ideal(Payment.stripeData);
      return false;
    } else if (Payment.paymentType === PAYMENT_TYPE_KLARNA) {
      Payment.klarna(Payment.stripeData);
      return false;
    } else {
      if (Payment.serviceID == 1 || Payment.serviceID == 2 || Payment.serviceID == 3) {
        Payment.pay(Payment.stripeData, null, null);
      } else {
        Payment.pay(Payment.stripeData.stripe, Payment.stripeData.card, Payment.stripeData.clientSecret);
      }
    }
  },
  initPaymentIntent: function initPaymentIntent() {
    var dataParse = Payment.stripePaymentIntent;
    Payment.stripeData = Payment.setupElements(dataParse);
    document.querySelector(Payment.payButton).addEventListener("click", function (event) {
      event.preventDefault();
      if (PAYMENT_PAGE || PAYMENT_TASK_PAGE) {
        Payment.ajax.validateBillingData();
      } else if (PAYMENT_PLANS_PAGE) {
        Payment.ajax.validateUserBillingData();
      } else if (PAYMENT_TASK_SEARCH_PAGE) {
        Payment.ajax.validateBillingData(35);
      } else {
        Payment.payFunction();
      }
    });
  },
  ajax: {
    obj: {},
    url: CLIENT_AJAX_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON');
    },
    createPaymentIntent: function createPaymentIntent() {
      this.obj.method = 'createPaymentIntent';
      this.obj.amount = $('#sender-payment-amount').data('amount');
      this.send(function (data) {
        var dataParse = JSON.parse(data.data.toString());
        Payment.stripeData = Payment.setupElements(dataParse);
        document.querySelector(Payment.payButton).addEventListener("click", function (event) {
          event.preventDefault();
          if (PAYMENT_PAGE) {
            Payment.ajax.validateBillingData();
          } else {
            Payment.payFunction();
          }
        });
      });
    },
    validateBillingData: function validateBillingData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 11;
      this.obj.method = 'validateBillingData';
      this.obj.type = type;
      this.obj.data = $('form.form-billing').serializeArray();
      this.send(function () {
        Payment.payFunction();
      }, function (answer) {
        $.each(answer.errors, function (name, value) {
          Step.showErrors(name, value);
        });
        Step.scrollToError(Object.keys(answer.errors)[0]);
        Payment.showGeneralError(answer.mainError);
      });
    },
    validateUserBillingData: function validateUserBillingData() {
      this.obj.method = 'validateUserBillingData';
      this.send(function () {
        Payment.payFunction();
      }, function (answer) {
        $('.download-offer-popup').find('form').attr('data-type', FORM_TYPE_PROFILE_CLIENT_PAYOUT_METHOD_SUBSCRIPTION);
        $('.download-offer-popup').addClass('active');
      });
    },
    validateCoupon: function validateCoupon() {
      this.obj.method = 'validateCoupon';
      this.obj.coupon = Payment.coupon;
      this.obj.amount = Payment.amount;
      this.send(function (answer) {
        Payment.couponID = answer.couponID;
        Payment.ajax.changePayoutOptions();
      }, function (answer) {
        $('.coupon').find('.error').text(answer.error);
      });
    },
    savePayment: function savePayment(paymentIntentID) {
      var _Payment$bonusType;
      var callbackUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.obj.method = 'savePayment';
      this.obj.serviceType = Payment.serviceType;
      this.obj.serviceID = Payment.serviceID;
      this.obj.amount = Payment.amount;
      this.obj.bonus = Payment.bonus;
      this.obj.bonusType = (_Payment$bonusType = Payment.bonusType) !== null && _Payment$bonusType !== void 0 ? _Payment$bonusType : 0;
      this.obj.payableNow = Payment.payableNow;
      this.obj.payoutOption = Payment.payoutOption;
      this.obj.type = Payment.type;
      this.obj.paymentType = Payment.paymentType;
      this.obj.paymentIntentID = paymentIntentID;
      this.obj.couponID = Payment.couponID;
      this.obj.autoRenew = Payment.autoRenew;
      this.send(function (answer) {
        if (Payment.paymentType === PAYMENT_TYPE_CARD) {
          if (PAYMENT_TASK_PAGE) {
            $('.popup--payment').removeClass('active');
            $('.popup--payment--form').html('');
            $('.thanks-reservation--popup').addClass('active');
          } else if (PAYMENT_TASK_SEARCH_PAGE) {
            $('#plans-payment-popup').html('');
            $('.popup--payment').removeClass('active');
            $('.plan-payed-success--popup').addClass('active');
            setTimeout(function () {
              $('.plan-payed-success--popup').removeClass('active');
              Client.ajax.getOpenOffers($('.choose-plan--popup').attr('data-hash'));
            }, 1500);
          } else if (Payment.serviceID == 1 || Payment.serviceID == 2 || Payment.serviceID == 3) {
            window.location.replace(callbackUrl);
          } else if (Payment.serviceType == '4') {
            $('.popup-thank').addClass('active');
            setTimeout(function () {
              window.location.replace(answer.callbackUrl);
            }, 10000);
          } else {
            window.location.replace(answer.successCallbackUrl);
          }
        } else {
          window.location.replace(callbackUrl);
        }
      });
    },
    getMaxBonus: function getMaxBonus(total) {
      this.obj.method = 'getMaxBonus';
      this.obj.total = total;
      this.send(function (answer) {
        $('#redeem-bonus-amount').val(answer.bonus);
      });
    },
    changePayoutOptions: function changePayoutOptions() {
      var formData = new FormData();
      formData.append('bonus', Payment.appliedBonus);
      formData.append('coupon', Payment.coupon);
      formData.append('bonusType', Payment.bonusType);
      formData.append('billingInfo', JSON.stringify($('form.form-billing').serializeArray()));
      formData.append('payoutOption', $('[name="payment-gateway-page-payout-option"]:checked').val());
      $.ajax({
        url: window.location.href,
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        success: function success(answer) {
          var data = JSON.parse(answer);
          if (data.result) {
            $('#content').html(data.html);
            ++Payment.initCounter;
            Payment.init();
          } else {
            $('.redeem-bonus-error').show();
            setTimeout(function () {
              $('.redeem-bonus-error').hide();
            }, 1500);
          }
        },
        error: function error() {}
      });
    }
  }
};